import { linkFaces } from '@vlabs/api/luna-api/client';

import { fetchFirstPageFaceIdsWithoutCards, PAGE_SIZE } from './shared';

export async function detachAllFacesFromList(listId: string): Promise<void> {
  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const faceIds = await fetchFirstPageFaceIdsWithoutCards(listId);

    if (faceIds.length === 0) return;

    // eslint-disable-next-line no-await-in-loop
    await linkFaces(listId, {
      action: 'detach',
      face_ids: faceIds,
    });

    if (faceIds.length < PAGE_SIZE) return;
  }
}
